// "use client"

// import { useState, useEffect } from "react"
// import { Minus, Plus, ArrowRight, X } from "lucide-react"
// import ProductVariantSelector from "./ProductVariantSelector"
// import NutritionalInfo from "./NutritionalInfo"
// import ImageGallery from "./ImageGallery"
// import "./product-details.css"
// import { useMediaQuery } from "react-responsive"
// import { useSearchParams } from "react-router-dom"
// import { useCart } from "../../context/CartContext"
// import Classic from "../../components/Classic/index"
// import 'react-loading-skeleton/dist/skeleton.css'
// import Preloader from "../Preloader"

// import { useSelector } from "react-redux"

// export default function Singleproduct() {
//   // const [quantity, setQuantity] = useState(1)
//   const [selectedVariant, setSelectedVariant] = useState(0)
//   const [activeTab, setActiveTab] = useState("description")
//   const [productData, setProductData] = useState(null)
//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState(null)
//   const [animationClass, setAnimationClass] = useState("")
//   const [relatedProducts, setRelatedProducts] = useState([])
//   const [loadingRelated, setLoadingRelated] = useState(true)
//   const [showLoginModal, setShowLoginModal] = useState(false)
//   const isDesktop = useMediaQuery({ minWidth: 768 })
//   const { cart, addToCart, updateQuantity } = useCart()

//   const user = useSelector((state) => state.auth.user)

//   // Get product ID from URL params
//   const [searchParams] = useSearchParams()
//   const productId = searchParams.get("id")

//   const redirectToLogin = () => {
//     window.location.href = "/login"
//   }



//   useEffect(() => {
//     const fetchProductData = async () => {
//       try {
//         setLoading(true)
//         const response = await fetch(`https://derbyb.ritaz.in/api/products/${productId}`)
//         if (!response.ok) {
//           throw new Error("Failed to fetch product data")
//         }

//         const data = await response.json()

//         setProductData(data.product)
//         setLoading(false)

//         // After getting product data, fetch related products
//         if (data.product && data.product.category) {
//           fetchRelatedProducts(data.product.category, data.product._id)
//         }
//       } catch (err) {
//         setError(err.message)
//         setLoading(false)
//       }
//     }

//     const fetchRelatedProducts = async (category, currentProductId) => {
//       try {
//         setLoadingRelated(true)
//         // Fetch products with the same category but exclude the current product
//         const response = await fetch(`https://derbyb.ritaz.in/api/products/category/${category}`, {
//           headers: {
//             "Content-Type": "application/json",
//           },
//           method: "GET",
//         })
//         if (!response.ok) {
//           throw new Error("Failed to fetch related products")
//         }

//         const data = await response.json()
//         // Filter out the current product from related products
//         const filtered = data.products.filter(product => product._id !== currentProductId)
//         setRelatedProducts(filtered)
//         setLoadingRelated(false)
//       } catch (err) {
//         console.error("Error fetching related products:", err)
//         setLoadingRelated(false)
//       }
//     }

//     if (productId) {
//       fetchProductData()
//     }
//   }, [productId])

//   if (loading) {
//     return (
//       <>
//         <Preloader />
//       </>
//     )
//   }

//   if (error) {
//     return <div className="product_details_wrapper">Error: {error}</div>
//   }

//   if (!productData) {
//     return <div className="product_details_wrapper">Product not found</div>
//   }

//   const currentVariant = productData.variants[selectedVariant]

//   const handleAddToCart = () => {
//     if (!user) {
//       setShowLoginModal(true)
//       return
//     }

//     // Add to cart using the context method
//     addToCart(productData._id)

//     // Set animation class
//     setAnimationClass("counter-animation-up")

//     // Reset animation after duration
//     setTimeout(() => {
//       setAnimationClass("")
//     }, 500)
//   }

//   const increaseQuantity = () => {
//     // Set animation class
//     setAnimationClass("counter-animation-up")

//     // Call the context method to update quantity
//     updateQuantity(productData._id, (cart[productData._id] || 0) + 1)

//     // Reset animation after duration
//     setTimeout(() => {
//       setAnimationClass("")
//     }, 500)
//   }

//   const decreaseQuantity = () => {
//     // Set animation class
//     setAnimationClass("counter-animation-down")

//     // Call the context method to update quantity
//     updateQuantity(productData._id, (cart[productData._id] || 0) - 1)

//     // Reset animation after duration
//     setTimeout(() => {
//       setAnimationClass("")
//     }, 500)
//   }

//   const images = [productData.mainImage, ...productData.otherImages]
//   return (
//     <div>

//       {showLoginModal && (
//         <div className="login-modal-overlay">
//           <div className="login-modal">
//             <div className="login-modal-close" onClick={() => setShowLoginModal(false)}>
//               <X size={24} />
//             </div>
//             <h3 className="login-modal-title">Login Required</h3>
//             <div className="login-modal-content">
//               <p>Please login to add items to your cart.</p>
//             </div>
//             <div className="login-modal-buttons">
//               <button className="login-button" onClick={redirectToLogin}>
//                 Login
//               </button>
//               <button className="cancel-button" onClick={() => setShowLoginModal(false)}>
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="product_details_wrapper" style={{ margin: isDesktop ? "100px" : "10px" }}>
//         {/* Main Product Section with Sticky Left Side */}
//         <div className="product_details_main_section">
//           {/* Left Column - Product Images (Sticky) */}
//           <div className="product_details_left_column">
//             <div className="product_details_sticky_container">
//               <div className="product_details_image_container">
//                 <ImageGallery images={images} variant={currentVariant.flavor} />
//               </div>

//               {/* Mobile-only tabs navigation */}
//               <div className="product_details_mobile_tabs">
//                 <div className="product_details_tabs_header">
//                   <button
//                     className={`product_details_tab_btn ${activeTab === "description" ? "product_details_tab_active" : ""}`}
//                     onClick={() => setActiveTab("description")}
//                   >
//                     Description
//                   </button>
//                   <button
//                     className={`product_details_tab_btn ${activeTab === "additional" ? "product_details_tab_active" : ""}`}
//                     onClick={() => setActiveTab("additional")}
//                   >
//                     Additional Information
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right Column - Product Info and Tabs */}
//           <div className="product_details_right_column">
//             {/* Product Info */}
//             <div className="product_details_info_container">
//               {/* Rating */}
//               <div className="product_details_rating">
//                 {[1, 2, 3, 4, 5].map((star) => (
//                   <svg key={star} className="product_details_star" fill="currentColor" viewBox="0 0 20 20">
//                     <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                   </svg>
//                 ))}
//                 <span className="product_details_rating_text">(4.9/5)</span>
//               </div>

//               {/* Product Title */}
//               <h1 className="product_details_title">{productData.name}</h1>

//               {/* Price */}
//               <div className="product_details_price_container">
//                 <span className="product_details_current_price">₹{productData.sellingPrice}</span>
//                 <span className="product_details_original_price">₹{productData.mrp}</span>
//                 <span className="product_details_discount_badge">
//                   {Math.round((1 - productData.sellingPrice / productData.mrp) * 100)}% OFF
//                 </span>
//               </div>

//               {/* Discount Badge */}
//               {productData.discounts && productData.discounts !== "none" && (
//                 <div className="product_details_offer_badge_container">
//                   <span className="product_details_offer_badge">{productData.discounts}</span>
//                 </div>
//               )}

//               {/* Description */}
//               <p className="product_details_description">{productData.description.substring(0, 150)}...</p>

//               {/* Variant Selector */}
//               <ProductVariantSelector
//                 variants={productData.variants.map((v) => v.flavor)}
//                 selectedVariant={selectedVariant}
//                 onSelectVariant={setSelectedVariant}
//               />

//               {/* Quantity and Add to Cart */}
//               <div className="product_details_actions">
//                 {cart && cart[productData._id] ? (
//                   <div
//                     className="quantity-selector"
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       backgroundColor: "#fff",
//                       border: "1px solid #e0e0e0",
//                       borderRadius: "50px",
//                       padding: "3px",
//                       boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
//                       width: "fit-content",
//                     }}
//                   >
//                     <button
//                       onClick={decreaseQuantity}
//                       style={{
//                         width: "28px",
//                         height: "28px",
//                         border: "none",
//                         backgroundColor: "transparent",
//                         color: "#333",
//                         borderRadius: "50%",
//                         cursor: "pointer",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         fontWeight: "bold",
//                         fontSize: "16px",
//                         transition: "all 0.2s ease",
//                       }}
//                     >
//                       <Minus size={16} />
//                     </button>
//                     <span
//                       className={animationClass}
//                       style={{
//                         margin: "0 15px",
//                         fontWeight: "400",
//                         color: "black",
//                         fontSize: "16px",
//                       }}
//                     >
//                       {cart[productData._id]}
//                     </span>
//                     <button
//                       onClick={increaseQuantity}
//                       style={{
//                         width: "28px",
//                         height: "28px",
//                         border: "none",
//                         backgroundColor: "transparent",
//                         color: "#333",
//                         borderRadius: "50%",
//                         cursor: "pointer",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         fontWeight: "bold",
//                         fontSize: "16px",
//                         transition: "all 0.2s ease",
//                       }}
//                     >
//                       <Plus size={16} />
//                     </button>
//                   </div>
//                 ) : (
//                   <button
//                     className="product_details_add_to_cart_btn"
//                     onClick={handleAddToCart}
//                     style={{
//                       background: "linear-gradient(90deg, #E0A323 0%, #FEBA2A 100%)",
//                       color: "#fff",
//                       border: "none",
//                       borderRadius: "50px",
//                       padding: "8px 15px",
//                       fontSize: "14px",
//                       fontWeight: "bold",
//                       cursor: "pointer",
//                       transition: "all 0.3s ease",
//                       boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "6px",
//                     }}
//                   >
//                     Add to Cart
//                     <ArrowRight className="product_details_icon" />
//                   </button>
//                 )}
//               </div>
//             </div>

//             {/* Desktop Tabs - Now on the right side */}
//             <div className="product_details_desktop_tabs">
//               <div className="product_details_tabs_container">
//                 <div className="product_details_tabs_header">
//                   <button
//                     className={`product_details_tab_btn ${activeTab === "description" ? "product_details_tab_active" : ""}`}
//                     onClick={() => setActiveTab("description")}
//                   >
//                     Description
//                   </button>
//                   <button
//                     className={`product_details_tab_btn ${activeTab === "additional" ? "product_details_tab_active" : ""}`}
//                     onClick={() => setActiveTab("additional")}
//                   >
//                     Additional Information
//                   </button>
//                 </div>

//                 <div className="product_details_tab_content">
//                   {activeTab === "description" && (
//                     <div className="product_details_description_content">
//                       <h3 className="product_details_content_title">Product Description</h3>
//                       <p>{productData.description}</p>
//                       <p>
//                         Package Quantity: {productData.packageSize} Psc.
//                         <br />
//                         Package Weight: {productData.packageWeight}
//                       </p>
//                     </div>
//                   )}

//                   {activeTab === "additional" && (
//                     <div className="product_details_additional_content">
//                       <div className="product_details_info_section">
//                         <h3 className="product_details_content_title">Ingredients</h3>
//                         <p className="product_details_info_text">{currentVariant.ingredients}</p>
//                       </div>

//                       <div className="product_details_info_section">
//                         <h3 className="product_details_content_title">Allergen Information</h3>
//                         <p className="product_details_allergen_text">{currentVariant.allergenInfo}</p>
//                       </div>

//                       <div className="product_details_info_section">
//                         <h3 className="product_details_content_title">Packaging</h3>
//                         <p className="product_details_info_text">{currentVariant.packagingOption}</p>
//                       </div>

//                       <div className="product_details_info_section">
//                         <h3 className="product_details_content_title">Nutritional Information</h3>
//                         <NutritionalInfo nutritionalFacts={currentVariant.nutritionalFacts} />
//                       </div>
//                     </div>
//                   )}

//                   {activeTab === "reviews" && (
//                     <div className="product_details_reviews_content">
//                       <h3 className="product_details_content_title">Customer Reviews</h3>
//                       <p className="product_details_no_reviews">No reviews yet. Be the first to review this product!</p>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Mobile-only tab content */}
//         <div className="product_details_mobile_tab_content">
//           {activeTab === "description" && (
//             <div className="product_details_description_content">
//               <h3 className="product_details_content_title">Product Description</h3>
//               <p>{productData.description}</p>
//               <p>
//                 Package Quantity: {productData.packageSize}
//                 <br />
//                 Package Weight: {productData.packageWeight}
//               </p>
//             </div>
//           )}

//           {activeTab === "additional" && (
//             <div className="product_details_additional_content">
//               <div className="product_details_info_section">
//                 <h3 className="product_details_content_title">Ingredients</h3>
//                 <p className="product_details_info_text">{currentVariant.ingredients}</p>
//               </div>

//               <div className="product_details_info_section">
//                 <h3 className="product_details_content_title">Allergen Information</h3>
//                 <p className="product_details_allergen_text">{currentVariant.allergenInfo}</p>
//               </div>

//               <div className="product_details_info_section">
//                 <h3 className="product_details_content_title">Packaging</h3>
//                 <p className="product_details_info_text">{currentVariant.packagingOption}</p>
//               </div>

//               <div className="product_details_info_section">
//                 <h3 className="product_details_content_title">Nutritional Information</h3>
//                 <NutritionalInfo nutritionalFacts={currentVariant.nutritionalFacts} />
//               </div>
//             </div>
//           )}

//           {activeTab === "reviews" && (
//             <div className="product_details_reviews_content">
//               <h3 className="product_details_content_title">Customer Reviews</h3>
//               <p className="product_details_no_reviews">No reviews yet. Be the first to review this product!</p>
//             </div>
//           )}
//         </div>
//         <hr />

//       </div>
//       {/* Related Products Section */}
//       {relatedProducts.length > 0 && (
//         <div className="related-products-section">
//           <Classic title="single-product" products={relatedProducts} loading={loadingRelated} error={error} />
//         </div>
//       )}
//     </div>
//   )
// }


"use client"

import { useState, useEffect } from "react"
import { Minus, Plus, ArrowRight, X } from "lucide-react"
import ProductVariantSelector from "./ProductVariantSelector"
import NutritionalInfo from "./NutritionalInfo"
import ImageGallery from "./ImageGallery"
import "./product-details.css"
import { useMediaQuery } from "react-responsive"
import { useSearchParams } from "react-router-dom"
import { useCart } from "../../context/CartContext"
import Classic from "../../components/Classic/index"
import "react-loading-skeleton/dist/skeleton.css"
import Preloader from "../Preloader"

import { useSelector } from "react-redux"

export default function Singleproduct() {
  const [selectedVariant, setSelectedVariant] = useState(0)
  const [activeTab, setActiveTab] = useState("description")
  const [productData, setProductData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [animationClass, setAnimationClass] = useState("")
  const [relatedProducts, setRelatedProducts] = useState([])
  const [loadingRelated, setLoadingRelated] = useState(true)
  const [showLoginModal, setShowLoginModal] = useState(false)
  const isMobile = useMediaQuery({ maxWidth: 767 })
  const isDesktop = useMediaQuery({ minWidth: 768 })
  const { cart, addToCart, updateQuantity } = useCart()

  const user = useSelector((state) => state.auth.user)

  // Get product ID from URL params
  const [searchParams] = useSearchParams()
  const productId = searchParams.get("id")

  const redirectToLogin = () => {
    window.location.href = "/login"
  }

  useEffect(() => {
    const fetchProductData = async () => {
      try {
        setLoading(true)
        const response = await fetch(`https://derbyb.ritaz.in/api/products/${productId}`)
        if (!response.ok) {
          throw new Error("Failed to fetch product data")
        }

        const data = await response.json()

        setProductData(data.product)
        setLoading(false)

        // After getting product data, fetch related products
        if (data.product && data.product.category) {
          fetchRelatedProducts(data.product.category, data.product._id)
        }
      } catch (err) {
        setError(err.message)
        setLoading(false)
      }
    }

    const fetchRelatedProducts = async (category, currentProductId) => {
      try {
        setLoadingRelated(true)
        // Fetch products with the same category but exclude the current product
        const response = await fetch(`https://derbyb.ritaz.in/api/products/category/${category}`, {
          headers: {
            "Content-Type": "application/json",
          },
          method: "GET",
        })
        if (!response.ok) {
          throw new Error("Failed to fetch related products")
        }

        const data = await response.json()
        // Filter out the current product from related products
        const filtered = data.products.filter((product) => product._id !== currentProductId)
        setRelatedProducts(filtered)
        setLoadingRelated(false)
      } catch (err) {
        console.error("Error fetching related products:", err)
        setLoadingRelated(false)
      }
    }

    if (productId) {
      fetchProductData()
    }
  }, [productId])

  if (loading) {
    return (
      <>
        <Preloader />
      </>
    )
  }

  if (error) {
    return <div className="product_details_wrapper">Error: {error}</div>
  }

  if (!productData) {
    return <div className="product_details_wrapper">Product not found</div>
  }

  const currentVariant = productData.variants[selectedVariant]

  const handleAddToCart = () => {
    if (!user) {
      setShowLoginModal(true)
      return
    }

    // Add to cart using the context method
    addToCart(productData._id)

    // Facebook Pixel - Track AddToCart
    if (typeof window.fbq === "function") {
      window.fbq("track", "AddToCart", {
        content_ids: [productData._id],
        content_type: "product",
        value: productData.price,
        currency: "INR",
      });
    }

    // Set animation class
    setAnimationClass("counter-animation-up")

    // Reset animation after duration
    setTimeout(() => {
      setAnimationClass("")
    }, 500)
  }

  const increaseQuantity = () => {
    // Set animation class
    setAnimationClass("counter-animation-up")

    // Call the context method to update quantity
    updateQuantity(productData._id, (cart[productData._id] || 0) + 1)

    // Reset animation after duration
    setTimeout(() => {
      setAnimationClass("")
    }, 500)
  }

  const decreaseQuantity = () => {
    // Set animation class
    setAnimationClass("counter-animation-down")

    // Call the context method to update quantity
    updateQuantity(productData._id, (cart[productData._id] || 0) - 1)

    // Reset animation after duration
    setTimeout(() => {
      setAnimationClass("")
    }, 500)
  }

  const images = [productData.mainImage, ...productData.otherImages]
  return (
    <div>
      {showLoginModal && (
        <div className="login-modal-overlay">
          <div className="login-modal">
            <div className="login-modal-close" onClick={() => setShowLoginModal(false)}>
              <X size={24} />
            </div>
            <h3 className="login-modal-title">Login Required</h3>
            <div className="login-modal-content">
              <p>Please login to add items to your cart.</p>
            </div>
            <div className="login-modal-buttons">
              <button className="login-button" onClick={redirectToLogin}>
                Login
              </button>
              <button className="cancel-button" onClick={() => setShowLoginModal(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="product_details_wrapper" style={{ margin: isDesktop ? "100px" : "10px" }}>
        {/* Main Product Section with Sticky Left Side */}
        <div className="product_details_main_section">
          {/* Left Column - Product Images (Sticky) */}
          <div className="product_details_left_column">
            <div className="product_details_sticky_container">
              <div className="product_details_image_container">
                <ImageGallery images={images} variant={currentVariant.flavor} />
              </div>

              {/* Mobile-only tabs navigation - MOVED to after Add to Cart */}
              {!isMobile && (
                <div className="product_details_mobile_tabs">
                  <div className="product_details_tabs_header">
                    <button
                      className={`product_details_tab_btn ${activeTab === "description" ? "product_details_tab_active" : ""}`}
                      onClick={() => setActiveTab("description")}
                    >
                      Description
                    </button>
                    <button
                      className={`product_details_tab_btn ${activeTab === "additional" ? "product_details_tab_active" : ""}`}
                      onClick={() => setActiveTab("additional")}
                    >
                      Additional Information
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Right Column - Product Info and Tabs */}
          <div className="product_details_right_column">
            {/* Product Info */}
            <div className="product_details_info_container">
              {/* Rating */}
              <div className="product_details_rating">
                {[1, 2, 3, 4, 5].map((star) => (
                  <svg key={star} className="product_details_star" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
                <span className="product_details_rating_text">(4.9/5)</span>
              </div>

              {/* Product Title */}
              <h1 className="product_details_title">{productData.name}</h1>

              {/* Price */}
              <div className="product_details_price_container">
                <span className="product_details_current_price">₹{productData.sellingPrice}</span>
                <span className="product_details_original_price">₹{productData.mrp}</span>
                <span className="product_details_discount_badge">
                  {Math.round((1 - productData.sellingPrice / productData.mrp) * 100)}% OFF
                </span>
              </div>

              {/* Discount Badge */}
              {productData.discounts && productData.discounts !== "none" && (
                <div className="product_details_offer_badge_container">
                  <span className="product_details_offer_badge">{productData.discounts}</span>
                </div>
              )}

              {/* Description */}
              <p className="product_details_description">{productData.description}</p>

              {/* Variant Selector */}
              <ProductVariantSelector
                variants={productData.variants.map((v) => v.flavor)}
                selectedVariant={selectedVariant}
                onSelectVariant={setSelectedVariant}
              />

              {/* Quantity and Add to Cart */}
              <div className="product_details_actions">
                {cart && cart[productData._id] ? (
                  <div
                    className="quantity-selector"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#fff",
                      border: "1px solid #e0e0e0",
                      borderRadius: "50px",
                      padding: "3px",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                      width: "fit-content",
                    }}
                  >
                    <button
                      onClick={decreaseQuantity}
                      style={{
                        width: "28px",
                        height: "28px",
                        border: "none",
                        backgroundColor: "transparent",
                        color: "#333",
                        borderRadius: "50%",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "bold",
                        fontSize: "16px",
                        transition: "all 0.2s ease",
                      }}
                    >
                      <Minus size={16} />
                    </button>
                    <span
                      className={animationClass}
                      style={{
                        margin: "0 15px",
                        fontWeight: "400",
                        color: "black",
                        fontSize: "16px",
                      }}
                    >
                      {cart[productData._id]}
                    </span>
                    <button
                      onClick={increaseQuantity}
                      style={{
                        width: "28px",
                        height: "28px",
                        border: "none",
                        backgroundColor: "transparent",
                        color: "#333",
                        borderRadius: "50%",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "bold",
                        fontSize: "16px",
                        transition: "all 0.2s ease",
                      }}
                    >
                      <Plus size={16} />
                    </button>
                  </div>
                ) : (
                  <button
                    className="product_details_add_to_cart_btn"
                    onClick={handleAddToCart}
                    style={{
                      background: "linear-gradient(90deg, #E0A323 0%, #FEBA2A 100%)",
                      color: "#fff",
                      border: "none",
                      borderRadius: "50px",
                      padding: "8px 15px",
                      fontSize: "14px",
                      fontWeight: "bold",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    Add to Cart
                    <ArrowRight className="product_details_icon" />
                  </button>
                )}
              </div>

              {/* Mobile-only tabs navigation - MOVED HERE after Add to Cart */}
              {isMobile && (
                <div className="product_details_mobile_tabs" style={{ marginTop: "20px" }}>
                  <div className="product_details_tabs_header">
                    <button
                      className={`product_details_tab_btn ${activeTab === "description" ? "product_details_tab_active" : ""}`}
                      onClick={() => setActiveTab("description")}
                    >
                      Description
                    </button>
                    <button
                      className={`product_details_tab_btn ${activeTab === "additional" ? "product_details_tab_active" : ""}`}
                      onClick={() => setActiveTab("additional")}
                    >
                      Additional Information
                    </button>
                  </div>
                </div>
              )}

              {/* Mobile-only tab content - MOVED HERE after tabs */}
              {isMobile && (
                <div className="product_details_mobile_tab_content">
                  {activeTab === "description" && (
                    <div className="product_details_description_content">
                      <h3 className="product_details_content_title">Product Description</h3>
                      <p>{productData.description}</p>
                      <p>
                        Package Quantity: {productData.packageSize}
                        <br />
                        Package Weight: {productData.packageWeight}
                      </p>
                    </div>
                  )}

                  {activeTab === "additional" && (
                    <div className="product_details_additional_content">
                      <div className="product_details_info_section">
                        <h3 className="product_details_content_title">Ingredients</h3>
                        <p className="product_details_info_text">{currentVariant.ingredients}</p>
                      </div>

                      <div className="product_details_info_section">
                        <h3 className="product_details_content_title">Allergen Information</h3>
                        <p className="product_details_allergen_text">{currentVariant.allergenInfo}</p>
                      </div>

                      <div className="product_details_info_section">
                        <h3 className="product_details_content_title">Packaging</h3>
                        <p className="product_details_info_text">{currentVariant.packagingOption}</p>
                      </div>

                      <div className="product_details_info_section">
                        <h3 className="product_details_content_title">Nutritional Information</h3>
                        <NutritionalInfo nutritionalFacts={currentVariant.nutritionalFacts} />
                      </div>
                    </div>
                  )}

                  {activeTab === "reviews" && (
                    <div className="product_details_reviews_content">
                      <h3 className="product_details_content_title">Customer Reviews</h3>
                      <p className="product_details_no_reviews">No reviews yet. Be the first to review this product!</p>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Desktop Tabs - Now on the right side */}
            <div className="product_details_desktop_tabs">
              <div className="product_details_tabs_container">
                <div className="product_details_tabs_header">
                  <button
                    className={`product_details_tab_btn ${activeTab === "description" ? "product_details_tab_active" : ""}`}
                    onClick={() => setActiveTab("description")}
                  >
                    Description
                  </button>
                  <button
                    className={`product_details_tab_btn ${activeTab === "additional" ? "product_details_tab_active" : ""}`}
                    onClick={() => setActiveTab("additional")}
                  >
                    Additional Information
                  </button>
                </div>

                <div className="product_details_tab_content">
                  {activeTab === "description" && (
                    <div className="product_details_description_content">
                      <h3 className="product_details_content_title">Product Description</h3>
                      <p>{productData.description}</p>
                      <p>
                        Package Quantity: {productData.packageSize} Psc.
                        <br />
                        Package Weight: {productData.packageWeight}
                      </p>
                    </div>
                  )}

                  {activeTab === "additional" && (
                    <div className="product_details_additional_content">
                      <div className="product_details_info_section">
                        <h3 className="product_details_content_title">Ingredients</h3>
                        <p className="product_details_info_text">{currentVariant.ingredients}</p>
                      </div>

                      <div className="product_details_info_section">
                        <h3 className="product_details_content_title">Allergen Information</h3>
                        <p className="product_details_allergen_text">{currentVariant.allergenInfo}</p>
                      </div>

                      <div className="product_details_info_section">
                        <h3 className="product_details_content_title">Packaging</h3>
                        <p className="product_details_info_text">{currentVariant.packagingOption}</p>
                      </div>

                      <div className="product_details_info_section">
                        <h3 className="product_details_content_title">Nutritional Information</h3>
                        <NutritionalInfo nutritionalFacts={currentVariant.nutritionalFacts} />
                      </div>
                    </div>
                  )}

                  {activeTab === "reviews" && (
                    <div className="product_details_reviews_content">
                      <h3 className="product_details_content_title">Customer Reviews</h3>
                      <p className="product_details_no_reviews">No reviews yet. Be the first to review this product!</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* REMOVED: Mobile-only tab content - Now moved inside the product info container */}
        <hr />
      </div>
      {/* Related Products Section */}
      {relatedProducts.length > 0 && (
        <div className="related-products-section">
          <Classic title="single-product" products={relatedProducts} loading={loadingRelated} error={error} />
        </div>
      )}
    </div>
  )
}
